"use client";import{createContext,useCallback,useState,useSyncExternalStore}from"react";export const Themes={Light:"Light",Dark:"Dark",System:"System"};export const ThemeContext=createContext({theme:Themes.Light});const localStorageKey="theme";const darkModeClass="dark rui:dark";/**
 * A hook to get and set the theme. With light and dark mode.
 *
 * @returns The current theme and a function to set the theme.
 */export function useTheme(){/**
	 * A pseudo state to force a re-render when the theme changes. (Since the
	 * actual state lives in local storage.)
	 */const[,forceUpdate]=useState(0);/** Manually overrides the system's theme. */const changeTheme=useCallback(newTheme=>{setLocalStorage(newTheme);forceUpdate(prev=>prev+1)},[]);const bodyThemeClass=useSyncExternalStore(subscribe,getClassToUse,()=>"");return{theme:getCurrentTheme(),changeTheme,bodyThemeClass}}/**
 * Gets the system's preferred colour scheme.
 *
 * @returns The system's preferred colour scheme. Default to light if the window
 *   is not available.
 */function getSystemTheme(){/* v8 ignore start */// This is to prevent the window object from being accessed in Node.js. I can't test this correctly.
if(typeof window==="undefined")return"Light";/* v8 ignore end */return getMediaMatch().matches?Themes.Dark:Themes.Light}/**
 * Sets the theme in local storage.
 *
 * @param newTheme The new theme to set.
 */function setLocalStorage(newTheme){if(typeof localStorage==="undefined"){return}if(newTheme===Themes.System){localStorage.removeItem(localStorageKey)}else{localStorage.theme=newTheme}}/**
 * Gets the current theme from local storage.
 *
 * @returns The current theme.
 * @throws Error If the theme in local storage is invalid.
 */function getCurrentTheme(){const storedTheme=typeof localStorage!=="undefined"?localStorage.getItem(localStorageKey):"";if(!storedTheme){return Themes.System}if(storedTheme===Themes.Light){return Themes.Light}if(storedTheme===Themes.Dark){return Themes.Dark}throw new Error("Invalid theme in local storage")}/**
 * Gets the class for use on the body based on the theme.
 *
 * @returns The class to use for the body.
 */function getClassToUse(){let classToUse="";const theme=getCurrentTheme();if(theme===Themes.Dark||theme===Themes.System&&getSystemTheme()===Themes.Dark){classToUse=darkModeClass}return classToUse}/**
 * Watches for changes to the system's preferred colour scheme and updates the
 * state. This is primarily for dev tools.
 *
 * @param callback The callback to call when the system's preferred colour
 *   scheme
 * @returns A function to unsubscribe from the listener.
 */function subscribe(callback){const mediaQueryList=getMediaMatch();mediaQueryList.addEventListener("change",callback);window.addEventListener("storage",callback);return()=>{mediaQueryList.removeEventListener("change",callback);window.removeEventListener("storage",callback)}}/**
 * Gets the media match for the system's preferred colour scheme.
 *
 * @returns The media match.
 */function getMediaMatch(){return window.matchMedia("(prefers-color-scheme: dark)")}